import { render, staticRenderFns } from "./DeliveryInventoryForm.vue?vue&type=template&id=08b57582&"
import script from "./DeliveryInventoryForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInventoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports